import { Link } from 'react-router-dom';
import styles from './NotFound.module.scss';

const NotFound = () => {
  return (
    <div className={styles.wrapper}>
      <main className={styles.content} aria-labelledby="not-found-heading">
        <p className={styles.code} aria-hidden="true">
          404
        </p>
        <h1 id="not-found-heading" className={styles.heading}>
          We can’t find that page
        </h1>
        <p className={styles.description}>
          The page you’re looking for may have moved or no longer exists. Try
          heading back to the documents list or reach out if you need a hand.
        </p>
        <div className={styles.actions}>
          <Link to="/" className={styles.homeLink}>
            Back to documents
          </Link>
          <a className={styles.supportLink} href="mailto:support@bedsidedocs.com">
            Contact support
          </a>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
